export default __webpack_public_path__ + "static/media/logo-bionextlab.8afed6a7.svg";